module.exports = __webpack_public_path__ + "img/icon_5_53.3ad152c5.png";